import React from "react";

export default function CopyableInviteLink({link, size}) {
    return <input value={link} onFocus={e => e.target.select()} readOnly size={size ?? 32}/>;
}
